import { Box, Paper,Button, Typography,FormControl,FormLabel,RadioGroup,FormControlLabel,Radio} from "@mui/material"
import { TranslateText } from "../utils/googletranslator"
import CustomAxios from "../utils/CustomAxios"
import { useNavigate } from "react-router-dom"
import {CheckoutProvider} from '@stripe/react-stripe-js/checkout';
import { Elements } from "@stripe/react-stripe-js";
import {loadStripe} from '@stripe/stripe-js';
import { useState ,useEffect} from "react";
import PaymentForm from "../components/paymentForm";
import { useSelector } from "react-redux";
const stripePromise=loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)

const PaymentPage=()=>{
    const navigate=useNavigate()
    const id=useSelector(state=>state.user.id)
    const [clientSecret,setClientSecret]=useState(null)
    const [option,setOption]=useState(null)
    const [paymentMethod, setPaymentMethod] = useState('credit_card')
    const [paymentAmount, setPaymentAmount] = useState(null)
    const [paymentCurrency, setPaymentCurrency] = useState('USD')
    const [baseAmount, setBaseAmount] = useState(0)
    const [convenienceFeeMessage, setConvenienceFeeMessage] = useState('')
    const [pageLoading, setPageLoading] = useState(true)
    const [paymentError, setPaymentError] = useState('')

    // Fetch package details from backend and calculate initial amount
    useEffect(() => {
        const packageData = JSON.parse(localStorage.getItem('package'))
        // console.log("packageData",packageData)
        if (packageData ) {
            setPageLoading(true)
            setPaymentError('')
            // Fetch fresh package details from backend
            fetchPackageDetails(packageData)
        } else {
            setPaymentError('No plan selected for payment.')
            setPageLoading(false)
        }
    }, [])

    // Function to fetch package details from backend
    const fetchPackageDetails = async (packageId) => {
        try {
            const response = await CustomAxios.get(`products/${packageId}/`)
            // console.log("response",response)
            if (response.data) {
                const freshPackageData = response.data
                setBaseAmount(freshPackageData.selling_price)
            }
        } catch (error) {
            // console.error('Error fetching package details:', error)
            // Fallback to localStorage data if API fails
            const packageData = JSON.parse(localStorage.getItem('package'))
            if (packageData && typeof packageData === "object" && packageData.selling_price) {
                setBaseAmount(packageData.selling_price)
            } else {
                setPaymentAmount(null)
                setPaymentError('We could not load the selected plan amount. Please go back and select the plan again.')
            }
        } finally {
            setPageLoading(false)
        }
    }

    // Calculate payment amount based on payment method
    const calculatePaymentAmount = async (method, amount) => {
        // console.log("method",method, "amount",amount)   
        try {
            const response = await CustomAxios.post('calculate_payment_amount/', {
                payment_method: method,
                base_amount: amount
            })
            // console.log("response",response)
            if (response.data.success) {
                // Backend already includes convenience fee in the amount, so use directly
                setPaymentAmount(response.data.amount)
                setPaymentCurrency(response.data.currency)
                setConvenienceFeeMessage(response.data.convenience_fee_message || '')
            } else {
                // Fallback calculation with database rates
                try {
                    const fallbackResponse = await CustomAxios.get('get-currency-conversion-rate/', {
                        params: { currency_code: 'MYR' }
                    })

                    let conversionRate = 4.5 // Default fallback

                    if (fallbackResponse.data.success) {
                        conversionRate = fallbackResponse.data.intake_percentage || 4.5
                        // console.log('Using database conversion rate for fallback:', conversionRate)
                    } else {
                        // console.log('Database conversion rate not found, using fallback:', conversionRate)
                    }

                    if (method === 'credit_card') {
                        setPaymentAmount(amount)
                        setPaymentCurrency('USD')
                        setConvenienceFeeMessage('')
                    } else if (method === 'fpx') {
                        setPaymentAmount(amount * conversionRate)
                        setPaymentCurrency('MYR')
                        setConvenienceFeeMessage('')
                    }
                } catch (innerError) {
                    // console.error('Database currency conversion fallback error:', innerError)
                    // Ultimate fallback - try to get convenience fee data even in fallback
                    const fallbackRate = 4.5
                    if (method === 'credit_card') {
                        // Try to get USD convenience fee even in fallback
                        try {
                            const usdConversionResponse = await CustomAxios.get('get-currency-conversion-rate/', {
                                params: { currency_code: 'USD' }
                            })
                            if (usdConversionResponse.data.success && usdConversionResponse.data.convenience_fee_percentage > 0) {
                                const convenienceFee = amount * (usdConversionResponse.data.convenience_fee_percentage / 100)
                                const totalAmount = amount + convenienceFee
                                setPaymentAmount(totalAmount)
                                setConvenienceFeeMessage('Convenience fee: ' + usdConversionResponse.data.convenience_fee_percentage.toFixed(2) + '% of base amount ($' + convenienceFee.toFixed(2) + ')')
                            } else {
                                setPaymentAmount(amount)
                                setConvenienceFeeMessage('')
                            }
                        } catch (feeError) {
                            setPaymentAmount(amount)
                            setConvenienceFeeMessage('')
                        }
                        setPaymentCurrency('USD')
                    } else if (method === 'fpx') {
                        setPaymentAmount(amount * fallbackRate)
                        setPaymentCurrency('MYR')
                        setConvenienceFeeMessage('')
                    }
                }
            }
        } catch (error) {
            // console.error('Error calculating payment amount:', error)
            // Fallback calculation - get currency conversion rate from database
            try {
                // Get currency conversion rate from our database
                const fallbackResponse = await CustomAxios.get('get-currency-conversion-rate/', {
                    params: { currency_code: 'MYR' }
                })

                let conversionRate = 4.5 // Default fallback

                if (fallbackResponse.data.success) {
                    conversionRate = fallbackResponse.data.intake_percentage || 4.5
                    // console.log('Using database conversion rate:', conversionRate)
                } else {
                    // console.log('Database conversion rate not found, using fallback:', conversionRate)
                }

                if (method === 'credit_card') {
                    // Try to get USD convenience fee even in fallback
                    try {
                        const usdConversionResponse = await CustomAxios.get('get-currency-conversion-rate/', {
                            params: { currency_code: 'USD' }
                        })
                        
                        if (usdConversionResponse.data.success && usdConversionResponse.data.convenience_fee_percentage > 0) {
                            const convenienceFee = amount * (usdConversionResponse.data.convenience_fee_percentage / 100)
                            const totalAmount = amount + convenienceFee
                            console.log("totalAmount",totalAmount)
                            setPaymentAmount(totalAmount)
                            setConvenienceFeeMessage('Convenience fee: ' + usdConversionResponse.data.convenience_fee_percentage.toFixed(2) + '% of base amount ($' + convenienceFee.toFixed(2) + ')')
                        } else {
                            setPaymentAmount(amount)
                            setConvenienceFeeMessage('')
                        }
                    } catch (feeError) {
                        setPaymentAmount(amount)
                        setConvenienceFeeMessage('')
                    }
                    setPaymentCurrency('USD')
                } else if (method === 'fpx') {
                    setPaymentAmount(amount * conversionRate)
                    setPaymentCurrency('MYR')
                    setConvenienceFeeMessage('')
                }
            } catch (fallbackError) {
                // console.error('Database currency conversion error:', fallbackError)
                // Ultimate fallback with last known rate
                const lastKnownRate = 4.5
                if (method === 'credit_card') {
                    // Even in ultimate fallback, try to get USD convenience fee data
                    try {
                        const usdConversionResponse = await CustomAxios.get('get-currency-conversion-rate/', {
                            params: { currency_code: 'USD' }
                        })
                        if (usdConversionResponse.data.success && usdConversionResponse.data.convenience_fee_percentage > 0) {
                            const convenienceFee = amount * (usdConversionResponse.data.convenience_fee_percentage / 100)
                            const totalAmount = amount + convenienceFee
                            setPaymentAmount(totalAmount)
                            setConvenienceFeeMessage('Convenience fee: ' + usdConversionResponse.data.convenience_fee_percentage.toFixed(2) + '% of base amount ($' + convenienceFee.toFixed(2) + ')')
                        } else {
                            setPaymentAmount(amount)
                            setConvenienceFeeMessage('')
                        }
                    } catch (feeError) {
                        setPaymentAmount(amount)
                        setConvenienceFeeMessage('')
                    }
                    setPaymentCurrency('USD')
                } else if (method === 'fpx') {
                    setPaymentAmount(amount * lastKnownRate)
                    setPaymentCurrency('MYR')
                    setConvenienceFeeMessage('')
                }
            }
        }
    }

    // Recalculate when payment method changes
    useEffect(() => {
        if (baseAmount > 0) {
            let ignore = false

            const refreshAmount = async () => {
                setPageLoading(true)
                setPaymentError('')
                try {
                    await calculatePaymentAmount(paymentMethod, baseAmount)
                } catch (error) {
                    if (!ignore) {
                        setPaymentAmount(null)
                        setPaymentError('We could not refresh the payment amount. Please try again.')
                    }
                } finally {
                    if (!ignore) {
                        setPageLoading(false)
                    }
                }
            }

            refreshAmount()

            return () => {
                ignore = true
            }
        }
    }, [baseAmount, paymentMethod])

    useEffect(()=>{
        if (clientSecret){
            setOption({
                clientSecret,
                appearance:{
                        theme:"stripe"
                }
            })
        }
    },[clientSecret])
    
    const handleProceed=()=>{
        if (pageLoading || paymentAmount === null || paymentError) {
            return
        }
        const authToken = localStorage.getItem("authtoken")
        const flow = authToken ? "subscription" : "signup"
        localStorage.setItem("paymentFlow", flow)
        setPageLoading(true)
        const basePayload = {
            flow,
            package:JSON.parse(localStorage.getItem('package')),
            payment_method: paymentMethod,
        }
        const payload= flow==="signup"?{...basePayload,signup_session_id:id||JSON.parse(localStorage.getItem('user'))?.user_id}:{...basePayload,user_id:id||JSON.parse(localStorage.getItem('user'))?.user_id};
        CustomAxios.post('Payment_initiation/',payload).then(res=>{
            if (res.status==200){
                setClientSecret(res.data.clientSecret)
                if (res.data.signup_session_id) {
                    localStorage.setItem("signupSessionId", res.data.signup_session_id)
                }
                // localStorage.setItem("authtoken", res.data.access_token)
                // localStorage.setItem("refreshToken", res.data.refresh_token)
                // navigate("/")
            }
            else{
                // navigate("/login")
            }
        }).catch(err=>{// console.log(err)
            }).finally(() => setPageLoading(false))
    }
    const handleCancel=()=>{
        const signupSessionId = localStorage.getItem("signupSessionId")
        const authToken = localStorage.getItem("authtoken")

        if (window.history.length > 1) {
            navigate(-1)
            return
        }

        if (signupSessionId) {
            navigate("/signup")
            return
        }

        if (authToken) {
            navigate("/products")
            return
        }

        navigate("/login")
    }
    // const handleSubmit = async (event) => {
    //     event.preventDefault();
    //     if (!stripe || !elements) return;
    
    //     const result = await stripe.confirmCardPayment(clientSecret, {
    //       payment_method: {
    //         card: elements.getElement(CardElement),
    //       },
    //     });
    
    //     if (result.error) {
    //       // console.log(result.error.message);
    //     } else {
    //       if (result.paymentIntent.status === 'succeeded') {
    //         alert("Payment Successful!");
    //       }
    //     }
    //   };
    return (
        <Box sx={{ bgcolor: { sm: "grey.100", xs: "#fff" }, minHeight: "calc(100vh )", display:"flex", justifyContent:"center", alignItems:"center" }}>
            {/* <Header1 /> */}
            <Box component={Paper} sx={{ display: "flex", paddingTop: "144px",gap:"24px",mx:"24px" , position:"relative",padding:"24px"}}>
                {/* <AdminSidebar /> */}
                {option?
                 <Elements stripe={stripePromise} options={option}>
                                <PaymentForm/>
                 </Elements>
                :
                <Box sx={{ display:"flex", flexDirection:"column", gap:"24px", minWidth:"400px" }}>
                    <TranslateText sx={{ fontSize:"24px", fontWeight:"600" }} text="Payment Page">Select Payment Method</TranslateText>

                    {/* Payment Amount Display */}
                    <Box sx={{ p: 3, bgcolor: 'grey.50', borderRadius: 2, border: '1px solid', borderColor: 'grey.200' }}>
                        <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
                            Payment Amount
                        </Typography>
                        <Typography variant="h4" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                            {pageLoading || paymentAmount === null ? 'Loading...' : `${paymentCurrency === 'USD' ? '$' : 'RM'} ${paymentAmount.toFixed(2)}`}
                        </Typography>
                        {paymentError && (
                            <Typography variant="body2" sx={{ color: 'error.main', mt: 1, fontWeight: 600 }}>
                                {paymentError}
                            </Typography>
                        )}
                        {convenienceFeeMessage && (
                            <div style={{ marginTop: '8px', padding: '8px', backgroundColor: '#e3f2fd', borderRadius: '4px', border: '1px solid #2196f3' }}>
                                <Typography variant="body2" sx={{ color: '#0d47a1', fontWeight: 600, textAlign: 'center' }}>
                                    💳 Convenience Fee Collection
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#0d47a1', marginTop: '4px', textAlign: 'center', fontStyle: 'italic' }}>
                                    {convenienceFeeMessage}
                                </Typography>
                            </div>
                        )}
                        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
                            Amount will be charged in {paymentCurrency === 'USD' ? 'US Dollars (USD)' : 'Malaysian Ringgit (MYR)'}
                        </Typography>
                    </Box>

                    {/* Payment Method Selection */}
                    <FormControl component="fieldset">
                        <FormLabel component="legend" sx={{ fontSize: "18px", fontWeight: "500", mb: 2 }}>
                            Choose Payment Method
                        </FormLabel>
                        <RadioGroup
                            value={paymentMethod}
                            onChange={(e) => setPaymentMethod(e.target.value)}
                            sx={{ gap: 2 }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', p: 2, border: '1px solid', borderColor: 'grey.300', borderRadius: 1, cursor: 'pointer' }}
                                //  onClick={() => setPaymentMethod('credit_card')}
                                 >
                                <FormControlLabel
                                    value="credit_card"
                                    control={<Radio />}
                                    label={
                                        <Box>
                                            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                Credit/Debit Card
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                                Pay securely with Visa, Mastercard, or American Express
                                            </Typography>
                                        </Box>
                                    }
                                    sx={{ width: '100%', m: 0 }}
                                />
                            </Box>

                            <Box sx={{ display: 'flex', alignItems: 'center', p: 2, border: '1px solid', borderColor: 'grey.300', borderRadius: 1, cursor: 'pointer' }}
                                //  onClick={() => setPaymentMethod('fpx')}
                                 >
                                <FormControlLabel
                                    value="fpx"
                                    control={<Radio />}
                                    label={
                                        <Box>
                                            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                FPX Online Banking
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                                Pay directly from your Malaysian bank account
                                            </Typography>
                                        </Box>
                                    }
                                    sx={{ width: '100%', m: 0 }}
                                />
                            </Box>
                        </RadioGroup>
                    </FormControl>

                    {/* Action Buttons */}
                    <Box sx={{ display:"flex", gap:"12px", justifyContent:"flex-end", mt: 2 }}>
                        <Button variant="outlined" color="primary" sx={{ textTransform:"none" }} onClick={handleCancel}>
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            sx={{ textTransform:"none", px: 4 }}
                            onClick={handleProceed}
                            disabled={!paymentMethod || pageLoading || paymentAmount === null || !!paymentError}
                        >
                            {pageLoading || paymentAmount === null ? 'Preparing...' : `Proceed with ${paymentCurrency === 'USD' ? '$' : 'RM'} ${paymentAmount.toFixed(2)}`}
                        </Button>
                    </Box>
                </Box>}
                
            </Box>
        </Box>
    )
}

export default PaymentPage
